import { render } from "./DynamicChart.vue?vue&type=template&id=1697fe3a&scoped=true"
import script from "./DynamicChart.vue?vue&type=script&lang=js"
export * from "./DynamicChart.vue?vue&type=script&lang=js"

import "./DynamicChart.vue?vue&type=style&index=0&id=1697fe3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1697fe3a"]])

export default __exports__